import { autoinject, InlineViewStrategy } from 'aurelia-framework';
import moment from 'moment';

import { DateFormatValueConverter } from '~/converters/date-format';
import { ColumnDefinitionMap } from '~/models/column-definition';

@autoinject
export class DrilldownCommonModel {
	public viewStrategy: InlineViewStrategy;

	public converters: object;
	private nullTimestamp: string;

	constructor(
		private template: string,
		public model: object,
		public tableColumnDefinitions: ColumnDefinitionMap,
		public isArchive: boolean = false,
	) {
		this.converters = { dateFormat: new DateFormatValueConverter() };
		// fix for difference to how Tree View and Browser View set offset to null timestamps
		this.nullTimestamp = moment(
			'1900-01-01T00:00:00',
			DateFormatValueConverter.apiFormat,
		)
			.utc()
			.format(DateFormatValueConverter.apiFormat);
		if (
			moment(
				'1900-01-01T00:00:00',
				DateFormatValueConverter.apiFormat,
			).isDST()
		) {
			this.nullTimestamp = moment(
				'1900-01-01T00:00:00',
				DateFormatValueConverter.apiFormat,
			)
				.add(1, 'h')
				.utc()
				.format(DateFormatValueConverter.apiFormat);
		}
	}

	public getViewStrategy() {
		return this.template;
	}

	public attached() {
		// this empty method is required for popup dialog when we click on any row
	}
}
